import { useContext, useEffect, useState } from "react";
import ButtonIcon from "@components/buttonIcon/ButtonIcon";
import "./FormCadastro.scss";
import { useForm } from "react-hook-form";
import Input from "@components/input/Input";
import DropDownList from "@components/dropDownList/DropDownList";
import MessageServices from "@services/MessageServices";
import GlobalContext from "@context/GlobalContext";
import { Tooltip } from "react-tooltip";
import UtilServices from "@services/UtilServices";

export default function FormCadastro(props) {
  //Variaveis padrões
  const [state, dispatch] = useContext(GlobalContext);

  //Variaveis do form.
  const [openInput, setOpenInput] = useState(true);
  const [lstAdd, setLstAdd] = useState([]);
  const [disabled, setDisabled] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
    watch,
  } = useForm();

  useEffect(() => {
    handleMapDefaultValue(); //Inseri dados do defaultvalue
    handleLstAddDefaultValue(); //Adciona lstAdd
  }, [props.defaultValueLst]);

  useEffect(() => {
    if (props.limpar) {
      handleClear();
      props.setLimpar(false);
      setDisabled(false);
    }
  }, [props.limpar]);

  useEffect(() => {
    handleLstAddSetValue();
  }, [lstAdd]);

  /*Funções do DropDownLst.*/
  const [valueDropDownLst, setValueDropDownLst] = useState([]);
  function handleChangeDropDownLst(name, value, valueAdicionar) {
    setValue(name, value);
    setValueDropDownLst((prevState) => ({
      ...prevState,
      [name]: valueAdicionar,
    }));
  }
  /*Funções do DefaultValue.*/
  function handleMapDefaultValue() {
    //setValue
    props.lst.forEach((item) => {
      const value = item?.defaultValue;
      if (value && !item.adicionar) {
        setValue(item?.name, value === " " ? null : value); //Apenas para manter os valores nulos caso seja passo variavel " "
      }
    });

    //set no dropdownlst
    let lstDropDownLst = props.lst
      .filter((item) => item.tipo === "dropdownlist") // Filtra apenas os itens do tipo 'dropdownlist'
      .reduce((acc, item) => {
        acc[item.name] =
          item?.defaultValue && !item.adicionar
            ? item?.defaultValue === " "
              ? null
              : item?.defaultValue
            : valueDropDownLst[item.name];
        return acc;
      }, {}); // Inicializa um objeto vazio
    setValueDropDownLst(lstDropDownLst);
  }
  /*Funções Limpar Tudo.*/
  function handleClear() {
    reset();
    setLstAdd([]); //Clear listas adicionadas
    setValueDropDownLst([]); //Clear DropDownLst
    props.setDefaultValueLst([]); //Clear os defatultvalue
    props.setSubmit((prevState) => ({
      ...prevState,
      [props.keySubmit]: [],
    }));
  }
  /************Funções do lstAdd*****************/
  //Incrementa o lstAdd pelo defaultvalue.
  function handleLstAddDefaultValue() {
    /*--Quando o adicionar é individual--*/
    if (!props.adicionar) {
      let propslst = props.lst.filter(
        (item) =>
          item?.defaultValue !== "" &&
          item?.defaultValue !== undefined &&
          item?.defaultValue !== null &&
          item?.adicionar === true,
      );

      setLstAdd((prevState) => [
        ...prevState,
        ...propslst.flatMap((item) => {
          // Verifica se o defaultValue é um array
          const values = Array.isArray(item.defaultValue)
            ? item.defaultValue
            : [{ [item.name]: item.defaultValue }]; // Se não for array, cria um array com o valor

          return values
            .map((value) => ({
              id: UtilServices.generateUUID(), // Garante um ID único
              [item.name]: value[item.name] || value, // Aqui o valor será o item[name] ou o valor diretamente
            }))
            .filter(
              (newItem) =>
                !prevState.some(
                  (existingItem) =>
                    existingItem[item.name] === newItem[item.name],
                ),
            );
        }),
      ]);
    } else {
      /*--Quando o adicionar não for individual--*/
      // Valida se todos os campos foram preenchidos pelo default
      let isvalid = props.lst.filter(
        (item) =>
          (item?.defaultValue === "" ||
            item?.defaultValue === undefined ||
            item?.defaultValue === null) &&
          item?.obrigatorio === true,
      );

      if (isvalid.length === 0) {
        let lstFinal = [
          props.lst.reduce((acc, item) => {
            acc[item.name] = item.defaultValue ? item.defaultValue : "";
            return acc;
          }, {}),
        ];

        setLstAdd(lstFinal); //set a lista unica.
        reset(); //Inputs
        setValueDropDownLst([]); //Clear DropDownLst
      }
    }
  }
  //Exibir o lstAdd
  function handleExibeLst(key) {
    //Caso a key seja diferente de nulo.
    const filteredLst = key ? lstAdd.filter((item) => item[key]) : lstAdd;

    return (
      <div className={`formcadastro-lstadicionado ${key ? "" : "coletivo"}`}>
        {/* Iterar dinamicamente pelas propriedades do objeto */}
        {filteredLst.map((item, index) => (
          <div
            className="formcadastro-lstadicionado-group"
            key={index}
            style={{ marginBottom: "10px" }}
          >
            <div className="formcadastro-lstadicionado-item">
              {Object.entries(item)
                .filter(([key]) => key !== "id")
                .map(([key, value]) => (
                  <div key={key} style={{ fontFamily: "Roboto Light" }}>
                    <span style={{ fontFamily: "Roboto Regular" }}>
                      {key}:{" "}
                    </span>
                    {value}
                  </div>
                ))}
            </div>
            {!disabled && (
              <ButtonIcon
                Excluir
                titleExcluir="Excluir item"
                onExcluir={() => {
                  // Exclui o item de lstAdd
                  const updatedLstAdd = lstAdd.filter((e) => e.id !== item.id);
                  setLstAdd(updatedLstAdd);
                }}
                typeExcluir="button"
              />
            )}
          </div>
        ))}
      </div>
    );
  }
  //Função para adicionar no lstAdd
  function handleLstAdd(e) {
    //Objetos vazios.
    if (!e) return MessageServices.ShowWarning("Selecione um item na lista!");

    // Pegando dinamicamente a primeira chave do objeto
    const primeiroKey = Object.keys(e)[0];
    if (!e[primeiroKey])
      return MessageServices.ShowWarning("Selecione um item na lista!");

    /*---Quando o adicionar da lista não for de um input individual.---*/
    if (props.adicionar) {
      //Verifica se há duplicidade
      const isDuplicate = lstAdd.some((item) => {
        const { id, ...itemWithoutId } = item; // Remove o campo `id` do item existente
        const { id: newId, ...newItemWithoutId } = e; // Remove o campo `id` do novo item
        return (
          JSON.stringify(itemWithoutId) === JSON.stringify(newItemWithoutId)
        ); // Compara os objetos sem `id`
      });
      if (isDuplicate) {
        MessageServices.ShowWarning("Item já existe na lista!");
        return;
      }

      setLstAdd([...lstAdd, { ...e, id: lstAdd.length + 1 }]);
    } else {
      /*---Quando o adicionar da lista for individual por input.---*/
      //Verifica se há duplicidade
      const lstAddValues = lstAdd.flatMap((obj) => Object.values(obj));
      const isDuplicate = Object.values(e[primeiroKey]).some((value) =>
        lstAddValues.includes(value),
      );
      if (isDuplicate) {
        MessageServices.ShowWarning("Item já existe na lista!");
        // Limpar DropDownLst Selecionado
        setValueDropDownLst((prevState) => ({
          ...prevState,
          [primeiroKey]: "",
        }));
        return;
      }

      setLstAdd((prevState) => [
        ...prevState,
        {
          id: prevState.length + 1,
          [primeiroKey]: e[primeiroKey].key,
        },
      ]);

      // Limpar DropDownLst Selecionado
      setValueDropDownLst((prevState) => ({
        ...prevState,
        [primeiroKey]: "",
      }));
    }
  }
  //Função para adicionar no setValue quando houver alteração no lstAdd
  function handleLstAddSetValue() {
    if (lstAdd.length > 0) {
      const groupedValues = lstAdd.reduce((acc, item) => {
        Object.entries(item).forEach(([key, value]) => {
          if (key !== "id") {
            acc[key] = acc[key] || [];
            if (!acc[key].includes(value)) {
              acc[key].push(value);
            }
          }
        });
        return acc;
      }, {});

      // Atualiza o setValue com os valores agrupados dinamicamente
      Object.entries(groupedValues).forEach(([key, values]) => {
        setValue(key, values);
      });

      if (props.adicionar) {
        reset();
        setValueDropDownLst([]); //Clear DropDownLst
      }
    }
  }

  return (
    <div className="formcadastro">
      <div className={`formcadastro-a ${disabled ? "salvo" : ""}`}>
        <div
          className="formcadastro-a-b"
          onClick={() => {
            setOpenInput(!openInput);
          }}
        >
          <div className="formcadastro-icontitle">
            {props.icon}
            <p>{props.title}</p>
          </div>
          <ButtonIcon
            Arrow
            openSetArrow={openInput}
            setOpenSetArrow={setOpenInput}
            onArrow={() => {
              setOpenInput(!openInput);
            }}
          />
        </div>
        {/* Exibição dos inputs */}
        {openInput && (
          <>
            {props.adicionar && handleExibeLst()}
            <form
              onSubmit={handleSubmit((e) => {
                //Ser for lista.
                if (props.adicionar) {
                  handleLstAdd(e);
                  return;
                }

                //Valida o keyvalidation
                if (props?.keyValidation !== undefined) {
                  if (!props?.keyValidation) {
                    MessageServices.ShowWarning(props.messageValidation);
                    return;
                  }
                }

                props.handleSubmit(e);
                setDisabled(true);
                setOpenInput(false);
              })}
              className="row"
            >
              {props.lst.map((item, index) => {
                return (
                  <div
                    className={`formcadastro-a-c col-${item?.col}`}
                    style={{
                      marginTop: "10px",
                      display: item?.ocultar ? "none" : "",
                    }}
                  >
                    {item?.subtitulo ? (
                      <p
                        className="formcadastro-subtitulo"
                        style={{ display: item?.ocultar ? "none" : "" }}
                      >
                        {item.iconSubTitulo}
                        <p>{item?.subtitulo}</p>
                      </p>
                    ) : (
                      <div
                        className="formcadastro-a-c-a"
                        style={{ display: item?.ocultar ? "none" : "" }}
                      >
                        {item?.obrigatorio && (
                          <div className="formcadastro-obg"></div>
                        )}
                        {item?.tipo === "input" && !item?.ocultar ? (
                          <Input
                            key={index}
                            title={item?.title}
                            placeholder={item?.placeholder}
                            required={item?.obrigatorio}
                            setValue={setValue}
                            register={register}
                            errors={errors}
                            name={item?.name}
                            mask={item?.mask}
                            maxLength={item?.maxLength}
                            registerProps={{
                              required: item?.required,
                              validate: item?.isValid
                                ? {
                                    isValid: (value) =>
                                      item.isValid(value) || item.isValidDesc,
                                  }
                                : undefined,
                            }}
                            type={item?.type}
                            theme={item?.theme}
                            disabled={item.disabled ? item.disabled : disabled}
                            //Button
                            button={item.button}
                            iconButton={item.iconButton}
                            titleButton={item.titleButton}
                            typeButton={item.typeButton}
                            onClickButton={() => {
                              item.onClickButton(watch(item?.name)); //Função de fora.
                            }}
                            //Tooltip
                            tooltip={item.tooltip}
                            tooltipDescricao={item.tooltipDescricao}
                            tooltipId={"tooltip-003"}
                          />
                        ) : item?.tipo === "dropdownlist" && !item?.ocultar ? (
                          <DropDownList
                            title={item?.title}
                            theme={item?.theme}
                            data={item?.data}
                            setData={item?.setData}
                            name={item?.name}
                            placeholder={item?.placeholder}
                            required={item?.obrigatorio}
                            onChange={handleChangeDropDownLst}
                            register={register}
                            loading={item?.loading}
                            errors={errors}
                            disabled={disabled}
                            value={valueDropDownLst[item?.name]}
                            registerProps={{
                              required: item?.adicionar
                                ? false
                                : item?.required,
                              validate: item?.isValid
                                ? {
                                    isValid: (value) =>
                                      item?.isValid(value) || item?.isValidDesc,
                                  }
                                : item?.adicionar
                                ? {
                                    isValid: () =>
                                      lstAdd.some((listItem) =>
                                        listItem.hasOwnProperty(item?.name),
                                      ) || item?.required,
                                  }
                                : undefined, // Caso nenhum dos anteriores seja verdadeiro
                            }}
                            //Button
                            button={item?.button}
                            iconButton={item?.iconButton}
                            titleButton={item?.titleButton}
                            typeButton={item?.typeButton}
                            onClickButton={() => {
                              if (item?.adicionar) {
                                handleLstAdd(
                                  {
                                    [item?.name]: valueDropDownLst[item?.name],
                                  },
                                  true, //Individual
                                );

                                return;
                              }

                              item.onClickButton(valueDropDownLst(item?.name)); //Função de fora.
                            }}
                            //Tooltip
                            tooltip={item?.tooltip}
                            tooltipDescricao={item?.tooltipDescricao}
                            tooltipId={"tooltip-003"}
                            //Carregar pelo click
                            flgCarregarClick={item?.flgCarregarClick}
                            functionCarregarClick={item?.functionCarregarClick}
                          />
                        ) : null}
                        {/* Quando houver uma lista individual por input/DropDownList */}
                        {item?.adicionar &&
                          lstAdd.some((i) => i[item?.name]) &&
                          handleExibeLst(item?.name)}
                      </div>
                    )}
                  </div>
                );
              })}
              <div
                className="formcadastro-button"
                style={{
                  justifyContent:
                    props.adicionar || props.clear
                      ? "space-between"
                      : "flex-end",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "10px",
                  }}
                >
                  {props.clear && (
                    <ButtonIcon
                      Clear
                      titleClear={props.titleClear}
                      onClear={() => {
                        handleClear();
                      }}
                      disabledClear={disabled}
                      typeClear="button"
                    />
                  )}
                  {props.adicionar && (
                    <ButtonIcon
                      Criar
                      titleCriar={props.titleAdicionar}
                      disabledCriar={disabled}
                    />
                  )}
                  {disabled && (
                    <ButtonIcon
                      Editar
                      titleEditar={"Editar Registro"}
                      typeEditar="button"
                      onEditar={() => {
                        setDisabled(false);
                        //Quando existir eu apago o keyvalidation.
                        if (props.setKeyValidation !== undefined) {
                          props.setKeyValidation("");
                        }
                        props.setSubmit((prevState) => ({
                          ...prevState,
                          [props.keySubmit]: [],
                        }));
                      }}
                    />
                  )}
                </div>
                {props.save && (
                  <ButtonIcon
                    Salvar
                    titleSalvar={props.titleSalvar}
                    typeSalvar={props.adicionar ? "button" : "submit"}
                    disabledSalvar={disabled}
                    {...(props.adicionar
                      ? {
                          onSalvar: () => {
                            //Verifica se tem objetos na lista.
                            if (lstAdd.length === 0) {
                              MessageServices.ShowWarning(
                                "A lista não pode estar vazia. Adicione pelo menos um item!",
                              );
                              return;
                            }
                            //Valida o keyvalidation
                            if (props?.keyValidation !== undefined) {
                              if (!props?.keyValidation) {
                                MessageServices.ShowWarning(
                                  props.messageValidation,
                                );
                                return;
                              }
                            }
                            setDisabled(true);
                            setOpenInput(false);
                            props.handleSubmit(lstAdd);
                          },
                        }
                      : {})}
                  />
                )}
              </div>
            </form>
          </>
        )}
      </div>
      <Tooltip
        id="tooltip-003"
        place={props.tooltipPLace}
        style={{
          backgroundColor: props.tooltipBackground,
          color: props.tooltipFontColor,
          fontSize: props.tooltipFontSize,
          zIndex: 1,
        }}
      />
    </div>
  );
}

FormCadastro.defaultProps = {
  save: true,
  titleSalvar: "",
  clear: false,
  titleClear: "",
  adicionar: false,
  titleAdicionar: "",
  handleSubmit: () => {},
  lst: [],
  icon: "",
  title: "",
  setDefaultValueLst: () => null,
  defaultValueLst: "",
  tooltipBackground: "#ff7575c9", //Style tooltip
  tooltipPLace: "right", //Style tooltip
  tooltipFontSize: "14px", //Style tooltip
  tooltipFontColor: "#3c3a3e", //Style tooltip
};
